import { observer } from 'mobx-react-lite';
import '../../scss/distant.scss'
import React, { FC, useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Context } from '../..';
import { ModalPopover } from './modal/modal-popover-dist';
import DistantService from '../../services/DistantService';
import { isEmpty } from 'underscore';
import UserService from '../../services/UserService';
import { BallTriangle } from 'react-loader-spinner';

const DistanceTeacher: FC = () => {
    const { store, distantStore } = useContext(Context)
    const navigate = useNavigate();
    const [acceptModal, setAcceptModal] = useState(false);
    const [lkUrl, setLKUrl] = useState('')
    const [urlLoader, setURLLoader] = useState(false)


    const getParticipantInfo = async () => {
        const res = await DistantService.getDistantParticipant()
        const status = isEmpty(res.data.results) ? '' : res.data.results[0]['status']
        distantStore.setStatus(status)
    }

    useEffect(() => {
        if (distantStore.status === '') {
            getParticipantInfo()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [store.user])

    useEffect(() => {
        if (store.user.is_active) {
            if (store.user.is_staff) {
                if (!store.specInfo?.fio?.length
                    || !store.specInfo?.municipality?.length
                    || !store.specInfo?.phone?.length
                    || !store.specInfo?.snils?.length
                    || isEmpty(store.specInfo?.organizations)
                    || isEmpty(store.specInfo?.specializations)) {
                    navigate('/config');
                };
            } else if (!store.userInfo?.fio?.length
                || !store.userInfo?.snils?.length
                || !store.userInfo?.phone?.length) {
                navigate('/config');
            };
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [navigate]);

    const agreeToParticipate = async (status: string) => {
        await DistantService.createDistantParticipant({ status: status })
        setAcceptModal(false)
        getParticipantInfo()
    }

    const getMoodleUrl = async (status: string) => {
        setURLLoader(true);
        const mu = await UserService.goToMoodle({ fio: store.specInfo?.fio || ' ', status: status })
        const url = mu.data
        setLKUrl(url)
        window.open(url, '_blank')
        setURLLoader(false);
    };

    const buttonOfAccept = () => {
        return (store.user.is_staff ?
            (+distantStore.status === 0 ?
                <button className="btn btn-warning btn-lg" onClick={() => setAcceptModal(true)}><p className="zag4 m-1">ПРИНЯТЬ УЧАСТИЕ</p></button>
                : (lkUrl === '' ?
                    (urlLoader ?
                        <BallTriangle color="#1d7ea7" height={90} width={90} />
                        :
                        <button className="btn btn-warning btn-lg" onClick={() => {
                            getMoodleUrl(distantStore.status)
                        }}>
                            <p className="zag4 m-1">{`Личный кабинет ${distantStore.status}а`}</p>
                        </button>
                    )

                    :
                    <button className="btn btn-warning btn-lg">
                        <a href={lkUrl} target="_blank" style={{ textDecoration: "none" }} className="zag4 m-1" rel="noreferrer" onClick={() => setLKUrl('')}>
                            {`Личный кабинет ${distantStore.status}а`}
                        </a>
                    </button>
                )

            )
            :
            <>
                <p className='text-center text-light'>Могут участвовать только специалисты Инклюзивного навигатора!</p>
                <button className="btn btn-warning btn-lg" onClick={() => {
                    // getMoodleUrl(distantStore.status)
                    navigate('/login')
                }}>
                    <p className="zag4 m-1">войти / зарегистрироваться</p>
                </button>
            </>
        )
    }

    return (
        <div className="row distant-main">
            <div className="row distant-header">
                <video autoPlay muted loop>
                    <source src="/video/work.mp4" type="video/mp4" />
                </video>
                <div className="divBlock"></div>
                <div className="col-md-3">
                    <div className="zag">
                        <a href="https://education.bashkortostan.ru" target="_blank" rel="noreferrer">
                            <img className="ris" src="/images/morb.png" alt='' />
                            <h6 className="zag">Министерство образования и науки Республики Башкортостан</h6>
                        </a>
                    </div><br />

                    <div className="zag">
                        <a href="https://irorb.ru/" target="_blank" rel="noreferrer">
                            <div className='irorb'></div>
                            <h6 className="zag">Институт развития образования Республики Башкортостан</h6>
                        </a>
                    </div><br />
                    <div className="zag">
                        <a href="http://rcdo02.ru">
                            <img className="ris" src="http://rcdo02.ru/wp-content/uploads/2020/10/logo-white.png" alt='' />
                            <h6 className="zag">ГБОУ "Республиканский центр дистанционного образования детей-инвалидов"</h6>
                        </a>
                    </div>
                </div>


                <div className="col-md-9">
                    <div className="text-end">
                        <input type="button" className='btn btn-light' value="Инклюзивный навигатор" onClick={() => navigate('/')} />
                    </div>
                    <h3 className="zag3 pt-2">РЕСПУБЛИКАНСКИЙ КОНКУРС ИННОВАЦИОННОГО ОПЫТА ПЕДАГОГИЧЕСКИХ РАБОТНИКОВ<br /><br /></h3>
                    <h2 className="zag2 pt-4"><img className='logo-at-main' src='/images/loogo.png' alt='logo' />УЧИТЕЛЬ ДИСТАНЦИОННОГО ОБРАЗОВАНИЯ</h2>
                    <div className="row pt-1">
                        <div className="column">
                            <h2 className="zag22">{(new Date()).getFullYear()}</h2>
                        </div>
                        <div className="column">
                            <h3 className="zag3"><br />"Учитель работает над самой ответственной задачей — он формирует человека. Педагог — это инженер человеческих душ."</h3>
                            <p className="zag4"><br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Михаил Иванович Калинин</p>
                        </div>
                    </div><br />
                    <h3 className="zag3">январь - март</h3><br />
                    <div className="row justify-content-center pt-2">
                        <div className="col-md-6  text-center">
                            {buttonOfAccept()}
                        </div>
                    </div>
                </div>
            </div>

            <div className="row justify-content-center pt-5 bg-light">
                <div className="col-md-10">
                    <div className='h3 text-center text-primary'><strong>ДОКУМЕНТЫ</strong></div>
                    <ul className="bord">
                        <li><a href='/docs/Приказ_о_проведении_конкурса_ДУ.pdf' target="_blank"
                            rel="noreferrer">Приказ Министерства образования о проведении Республиканского конкурса
                            инновационного опыта педагогических работников "Учитель дистанционного образования"</a></li>
                        <li><a href='/docs/Состав_оргкомитета_и_члены_жюри_УДО.pdf' target="_blank"
                            rel="noreferrer">Состав организационного комитета конкурса</a></li>
                        <li><a href='/docs/Положение.pdf' target="_blank" rel="noreferrer">Положение о
                            проведении Республиканского конкурса инновационного опыта педагогических работников "Учитель
                            дистанционного образования"</a></li>
                        <li><a href='/docs/Заявка.jpeg' target="_blank" rel="noreferrer">Шаблон заявки</a></li>
                        <li><a href='/docs/Согласие.jpeg' target="_blank" rel="noreferrer">Согласие на обработку
                            персональных данных</a></li>
                        <li><a href='/docs/Выписка.jpeg' target="_blank" rel="noreferrer">Шаблон выписки из протокола
                            заседания МК ОУ</a></li>
                    </ul>
                </div>
            </div>

            <div className="row justify-content-center pt-5">
                <div className="col-md-10">
                    <div className="box15 p-5">
                        <p>&#8220;Стремление к развитию и внедрению новаторских методов обучения заслуживает особого
                            внимания и признания. Ваши творческие усилия и уникальные подходы к дистанционному обучению
                            являются важными факторами в повышении качества образования.</p>
                        <p>Желаю вдохновения и удачи в реализации ваших педагогических идей. Пусть профессионализм и
                            принятые инновации помогут в создании ярких образовательных практик, способствующих развитию
                            лучших образовательных стандартов.</p>
                        <p>Благодарю вас за ваш вклад в образование и желаю вам множество творческих успехов в конкурсе "Учитель дистанционного образования".&#8221;</p>
                        <br />
                        <p className='text-end fst-italic'>Министр образования и науки Республики Башкортостан</p>
                        <p className='text-end fst-italic'>Ильдар Маратович Мавлетбердин</p>
                    </div>
                </div>
            </div>

            <div className="row justify-content-center p-5 m-0 bg-dark">
                <div className="col-md-3">
                    {buttonOfAccept()}
                </div>
            </div>

            <ModalPopover
                toggle={acceptModal}
                setToggle={setAcceptModal}
                title='Выберите статус участия в конкурсе'
                modalContent={
                    <p>Нажимая на кнопку "конкурсант" или "эксперт",
                        вы становитесь участником конкурса "Дистанционный учитель - 2023"
                        и даете согласие на обработку Ваших персональных данных, запрашиваемых в процессе конкурса.</p>
                }
                clickedButtonOne={() => agreeToParticipate('конкурсант')}
                clickedButtonTwo={() => agreeToParticipate('эксперт')}
                ButtonOneValue='Конкурсант'
                ButtonTwoValue='Эксперт'
            />


        </div>

    )
};
export default observer(DistanceTeacher);